import { render, staticRenderFns } from "./InsTabs.vue?vue&type=template&id=3ce2b1e0"
import script from "./InsTabs.vue?vue&type=script&lang=js"
export * from "./InsTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports